import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap-v5";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import Loader from 'components/elements/Loader/Loader';

export default function ({ isLoading, isOpen, handleClose, title,size="lg", children, onPress,titleButton }: any) {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  return (
    <Modal size={size}  show={isOpen} onHide={handleClose}>
      {isLoading && <Loader />}
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
      </Modal>
  );
}
